import { render, staticRenderFns } from "./UpgradeVersion.vue?vue&type=template&id=a3ceb44c&scoped=true"
import script from "./UpgradeVersion.vue?vue&type=script&lang=js"
export * from "./UpgradeVersion.vue?vue&type=script&lang=js"
import style0 from "./UpgradeVersion.vue?vue&type=style&index=0&id=a3ceb44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ceb44c",
  null
  
)

export default component.exports